import Vue from "vue";
import VueTimeago from "vue-timeago";

Vue.use(VueTimeago, {});
